export * from './lib/module-addons/module-addons.component';
